<app-base-entry-dialog-template [value]="value" [formGroupRef]="formGroupRef" [isSaving]="isSaving"
                                (saveClick)="onSaveClicked()" (cancelClick)="onCancelClicked()">
  <app-offering-form
    [(formGroupRef)]="formGroupRef"
    [(value)]="value">
  </app-offering-form>
</app-base-entry-dialog-template>
